module.exports = __webpack_public_path__ + "static/media/DqEveryChildWorkshopParentGuide.0974d492.jpg";